import { Vector3 } from 'three'
import {LHFEventDispatcher} from "../../com/LHFEventDispatcher";

// 全景默认配置
const PANO_CONFIG = {
  FOV: 80,
  FOV_MIN: 30,
  FOV_MAX: 100,
  V_WIDTH: 1280,
  V_HEIGHT: 720,
  // 全景半径
  PAN_RATIO: 10000,
  // 全景宽度拆分
  PAN_W_SEG: 32,
  // 全景高度拆分
  PAN_H_SEG: 32,
  // 全景球缩放方式
  PAN_MESH_SCALE: new Vector3(-1, 1, 1),
  // 默认摄像头位置
  defaultCameraPosition: new Vector3(10, 0, 0),
  // 视频dom
  VIDEO_DOM:null,
  // 默认语言
  lang: 'cn-ZH'
}
/**
 * 根据当前语言版本获取值
 * @param {value} cn_
 * @param {value} en_
 */
function getLangValue(cn_, en_) {
  return PANO_CONFIG.lang === 'en-US' ? en_ : cn_
}

const globalEvent = new LHFEventDispatcher();

export { PANO_CONFIG, getLangValue,globalEvent }



// WEBPACK FOOTER //
// ./src/webgl/panorama/PanoConfig.js